import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/NPLDrivers/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/NPLDrivers/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/NPLDrivers/GetById`, payload),
    ResetPassword: (payload) => Repository.post(`/api/NPLDrivers/ResetPassword`, payload),
    Add: (payload) => Repository.post(`/api/NPLDrivers/Add`, payload),
    Edit: (payload) => Repository.post(`/api/NPLDrivers/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/NPLDrivers/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/NPLDrivers/ChangeStatus`, payload),
}